module.exports = __webpack_public_path__ + "static/media/udacity_logo.f4350f5e.svg";